import { render, staticRenderFns } from "./AppointmentsCalendar.vue?vue&type=template&id=81c75360&scoped=true"
import script from "./AppointmentsCalendar.vue?vue&type=script&lang=js"
export * from "./AppointmentsCalendar.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsCalendar.vue?vue&type=style&index=0&id=81c75360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c75360",
  null
  
)

export default component.exports